module.exports = __webpack_public_path__ + "img/ic-dropdown-arrow.5f0226d1.svg";